export default __webpack_public_path__ + "static/media/certificate-dashboard.ca4fa20b.png";